export default __webpack_public_path__ + "static/media/peak_packers_logo.132fecb4.jpg";